import { SOCIAL_PROVIDERS, TRUE_TO_STRING } from '@/constants';
import {
  googleSignIn,
  facebookSignIn,
  appleSignIn
} from '@/service/cognitoService';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

const socialProviderHandlers = new Map([
  [
    SOCIAL_PROVIDERS.APPLE, appleSignIn
  ],
  [
    SOCIAL_PROVIDERS.FACEBOOK, facebookSignIn
  ],
  [
    SOCIAL_PROVIDERS.GOOGLE, googleSignIn
  ]
]
);

export const beforeEachRoute = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const isIframe = String(to.query.iframe).toLowerCase() === TRUE_TO_STRING;
  const socialProvider = to.query.sp;

  store.dispatch('setIsIframe', isIframe);

  if (!isIframe && socialProvider) {
    const socialLoginHandler = socialProviderHandlers.get(socialProvider as string);
    if (socialLoginHandler) {
      await socialLoginHandler();
      return next(false);
    }
  }
  next();
};
